export function dateFormat (time, fmt = 'yyyy-MM-dd hh:mm:ss') {
  const curDate = new Date(time)
  const o = {
    'M+': curDate.getMonth() + 1,
    'd+': curDate.getDate(),
    'h+': curDate.getHours(),
    'm+': curDate.getMinutes(),
    's+': curDate.getSeconds(),
    'q+': Math.floor((curDate.getMonth() + 3) / 3)
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (curDate.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
